"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var focus_1 = require("../helpers/focus");
var keycodes_1 = __importDefault(require("../helpers/keycodes"));
var uuid_1 = require("../helpers/uuid");
var ItemContext_1 = require("./ItemContext");
var style = __importStar(require("./Accordion.style"));
var theme_1 = require("@prezzee/theme");
var tokens_1 = require("@prezzee/tokens");
var AccordionItemButton = function (_a) {
    var _b, _c;
    var toggleExpanded = _a.toggleExpanded, _d = _a.className, className = _d === void 0 ? 'accordion__button' : _d, _e = _a.variant, variant = _e === void 0 ? 'primary' : _e, rest = __rest(_a, ["toggleExpanded", "className", "variant"]);
    var theme = (0, theme_1.useTheme)();
    var handleKeyPress = function (evt) {
        var keyCode = evt.key;
        if (keyCode === keycodes_1.default.ENTER ||
            keyCode === keycodes_1.default.SPACE ||
            keyCode === keycodes_1.default.SPACE_DEPRECATED) {
            evt.preventDefault();
            toggleExpanded();
        }
        /* The following block is ignored from test coverage because at time
         * time of writing Jest/react-testing-library can not assert 'focus'
         * functionality.
         */
        // istanbul ignore next
        if (evt.target instanceof HTMLElement) {
            switch (keyCode) {
                case keycodes_1.default.HOME: {
                    evt.preventDefault();
                    (0, focus_1.focusFirstSiblingOf)(evt.target);
                    break;
                }
                case keycodes_1.default.END: {
                    evt.preventDefault();
                    (0, focus_1.focusLastSiblingOf)(evt.target);
                    break;
                }
                case keycodes_1.default.LEFT:
                case keycodes_1.default.UP: {
                    evt.preventDefault();
                    (0, focus_1.focusPreviousSiblingOf)(evt.target);
                    break;
                }
                case keycodes_1.default.RIGHT:
                case keycodes_1.default.DOWN: {
                    evt.preventDefault();
                    (0, focus_1.focusNextSiblingOf)(evt.target);
                    break;
                }
                default: {
                    //
                }
            }
        }
    };
    if (rest.id) {
        (0, uuid_1.assertValidHtmlId)(rest.id);
    }
    var backgroundColor = ((_c = (_b = theme === null || theme === void 0 ? void 0 : theme.components) === null || _b === void 0 ? void 0 : _b.accordions[variant]) === null || _c === void 0 ? void 0 : _c.panelBackgroundColor) || tokens_1.colors.white;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ css: [style.button, style.backgroundStyle(backgroundColor)], className: className }, rest, { role: "button", tabIndex: 0, onClick: toggleExpanded, onKeyDown: handleKeyPress, "data-accordion-component": "AccordionItemButton" })));
};
var AccordionItemButtonWrapper = function (props) { return ((0, jsx_runtime_1.jsx)(ItemContext_1.Consumer, { children: function (itemContext) {
        var toggleExpanded = itemContext.toggleExpanded, buttonAttributes = itemContext.buttonAttributes, variant = itemContext.variant;
        return ((0, jsx_runtime_1.jsx)(AccordionItemButton, __assign({ toggleExpanded: toggleExpanded }, props, buttonAttributes, { variant: variant })));
    } })); };
exports.default = AccordionItemButtonWrapper;
//# sourceMappingURL=AccordionItemButton.js.map